import { MessagesService } from './../services/messages.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';
import { DateService } from '../services/date.service';

@Component({
  selector: 'app-messages-list',
  templateUrl: './messages-list.component.html',
})
export class MessagesListComponent implements OnInit, AfterViewInit {

  displayConversations: string = 'all';
  conversations: any = {};
  messagesListLoading: Boolean = true;
  messagesStatuses: any = {};
  currentPage: Number = 1;
  maxPages: Number = 1;

  constructor(
    private messagesService: MessagesService,
    private localStorageService: LocalStorageService,
    private dateService: DateService,
  ) { }

  ngAfterViewInit() {
    this.messagesListLoading = true;
  }

  ngOnInit() {
    this.loadConversations(this.localStorageService.get('company'), this.currentPage);

    this.messagesStatuses = this.messagesService.states;
  }

  pageChange(event) {
    this.currentPage = event;
    this.toggleLoading(true);
    this.loadConversations(this.localStorageService.get('company'), this.currentPage);
  }

  loadConversations(company, page) {
    this.messagesService.getConversations(company, page).subscribe(
      (response) => {

        this.conversations = response['data']['tickets'];
        this.maxPages = Math.ceil(response['data']['max_count'] / 10);
        this.toggleLoading(false);
      }
    );
  }

  toggleLoading(value) {
    this.messagesListLoading = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/messages/messages-list.component.ts